<template>
	<div>
		<Banner></Banner>

		<BrandsLogos></BrandsLogos>

		<About></About>

		<OurOffer></OurOffer>

		<Types></Types>

    <TypeDiv></TypeDiv>

		<WhyChooseUs></WhyChooseUs>

    <Portfolio></Portfolio>

    <Const></Const>
	</div>
</template>

<script>
import Banner from '../../components/GameDevelopment/Main/Banner.vue';
import BrandsLogos from '../../components/AssetComponents/BrandsLogos.vue';
import About from '../../components/GameDevelopment/Main/About.vue';
import Types from '../../components/GameDevelopment/Main/Types.vue';
import OurOffer from '../../components/GameDevelopment/Main/OurOffer.vue';
import TypeDiv from '../../components/Home/TypeDiv.vue';
import WhyChooseUs from '../../components/GameDevelopment/Main/WhyChooseUs.vue';
import Portfolio from '../../components/Home/Portfolio.vue';
import Const from '../../components/AssetComponents/Const.vue';

export default {
	components: {
		Banner,
		BrandsLogos,
		About,
		OurOffer,
		Types,
    TypeDiv,
		WhyChooseUs,
    Portfolio,
    Const
	}
};
</script>

<style></style>
